import React from "react";
import {by_log} from "@bigyellow/api/customer";
import getConfig from "next/config";
import axios from "axios";

const ErrorComponent = () => {
    return <h1>Something went wrong</h1>;
};

class ErrorBoundary extends React.Component {
    state = {
        hasError: false,
        error: {message: "", stack: ""},
        info: {componentStack: ""}
    };

    static getDerivedStateFromError = error => {
        return {hasError: true};
    };

    componentDidCatch = (error, info) => {
        this.setState({error, info});

        const {publicRuntimeConfig} = getConfig();
        let axios_headers = {
            //all axios can be used, shown in axios documentation
            baseURL: publicRuntimeConfig.apiUrl ?? 'http://127.0.0.1:8080/api/v1',
            responseType: 'json',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                //'Accept-Language': 'en',
                //'Authorization': '',
                'X-Api-Key': publicRuntimeConfig.apiKey ?? '',
            },
        };

        const httpClient = axios.create(axios_headers);
        by_log(httpClient, "error", error, info);
    };

    render() {
        const {hasError, error, info} = this.state;
        const {children} = this.props;

        return hasError ? <ErrorComponent/> : children;
    }
}

export default ErrorBoundary;
